import * as React from 'react';
import { useState, useEffect, useContext } from "react";
import useFetch from "../../hooks/useFetch";
import { useHistory, Redirect } from 'react-router-dom';
import { CurrentUserContext } from "../../contexts/currentUser";
import { Page } from '../page';
import { FormButton } from '../../components/buttons/button';
import { TitledBlock } from '../../components/blocks/titledBlock/titledBlock';
import { AlertMesssage } from "../../components/blocks/alertMessage/alertMessage";
import {
    Row, FormBlock, FormItem, Title, TitleInput, ErrorMessage, SubmitButtonWrap, CancelButton,
    BigGreenText, DueDateText, NewAccountLink, NewAccountButton, RadioGroup, RadioButton,
    RadioInput, RadioLabel, PayButton, PayLink, AutopayButton, BoldText, AutopayOffButton
} from './autopay.styles';
import { useFormik, Field, FormikProvider } from 'formik';
import {AccountLink, EditAccountButton, PaymentButtonBroup} from "../payment/payment.styles";

const AutopayPage = () => {

    const [dueDate, setDueDate] = useState<string>('Loading...');
    const [autopayInfo, setAutoPayInfo] = useState<any>(null);
    const [days, setDays] = useState<number>(null);
    const [balance, setBalance] = useState<any>('Loading...');
    const [balance1, setBalance1] = useState<any>('0');
    const [total, setTotal] = useState<number>(0);
    const [fee, setFee] = useState<number>(0);
    const [leaseId, setLeaseId] = useState<number>(null);
    const [accounts, setAccounts] = useState<any>([]);
    const [error, setError] = useState<any>(null);
    const [reference, setReference] = useState(null);
    const [credit, setCredit] = useState<boolean>(false);
    const [isTotal, setIsTotal] = useState<boolean>(true);
    const [createAccount, setCreateAccount] = useState<boolean>(false);
    const [accountsLoaded, setAccountsLoaded] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [{ responses }, doFetch] = useFetch('balance');
    const [accountsResult, fetchAccounts] = useFetch('getBankAccounts');
    const [autopayResult1, fetchAutopay] = useFetch('getRecurring');
    const [autopayResult, setupAutopay] = useFetch('enableRecurring');
    const [autopayOffResult, deleteAutopay] = useFetch('enableRecurring');
    const history = useHistory();
    const [currentUserState] = useContext(CurrentUserContext);
    const [account, setAccount] = useState<number>(0);

    // Formik declaration & submission
    const formik = useFormik({
        initialValues: { amount: '', bank_account: '', end_date: 'lease_end', start_date: '' },
        validate,
        onSubmit: values => {
            setIsSubmitting(true);
            const profile_id = currentUserState.currentUser.id;
            const full_name = `${currentUserState.currentUser.first_name} ${currentUserState.currentUser.last_name}`;

            const options = { type: 'month', interval: 1 }
            const data = { ...values, ...options, full_name, profile_id, enable: true, fee: fee.toFixed(2)};
            console.log(data);
            setupAutopay({ method: 'POST', data });
        }
    });

    useEffect(() => {
        doFetch({ method: 'get' })
        fetchAccounts({ method: 'get' })
        fetchAutopay({ method: 'get' })
    }, []);

    useEffect(() => {
        if (!responses) return;
        setBalance(responses.rent);
        setBalance1(responses.rent);
        setDays(responses.days);
        setDueDate(responses.duedate);
        setLeaseId(responses.lease_id);
        formik.setFieldValue('amount', parseFloat(responses.rent.replace('$', '').replaceAll(',', '')));
    }, [responses]);

    useEffect(() => {
        if(!accounts[0] || !currentUserState.currentUser.settings) return;
        if(!account) setAccount(accounts[0].id);
        let acc = accounts.find((element:any) => {
            return element.id === account;
        })
        if(!acc) return;
        let fee0 = 0;
        let tempbalance = parseFloat(balance1.replace('$', '').replaceAll(',', ''));
        if(acc.cc == '0' && currentUserState.currentUser.settings.default_ach_fee) {
            setCredit(false);
            fee0 = parseFloat(currentUserState.currentUser.settings.default_ach_fee);
            setFee(fee0);
            setTotal(tempbalance + fee0);
        } else if(acc.cc == '1' && currentUserState.currentUser.settings.default_cc_fee) {
            setCredit(true);
            fee0 = currentUserState.currentUser.settings.default_cc_fee/100*tempbalance;
            setFee(fee0);
            setTotal(tempbalance + fee0);
        }
    }, [currentUserState.currentUser.settings, balance1, account]);

    useEffect(() => {
        if (autopayResult.errors) {
            setError(autopayResult.errors.message);
            setIsSubmitting(false);
        }
        if (!autopayResult.responses) return;
        history.push({
            pathname: '/autopay_confirmation',
            state: {
                start_date: autopayResult.responses.start_date
            },
        });
        setIsSubmitting(false);
    }, [autopayResult.responses, autopayResult.errors]);

    useEffect(() => {
        if (autopayOffResult.errors) {
            setError(autopayOffResult.errors.message);
            setIsSubmitting(false);
        }
        if (!autopayOffResult.responses) return;
        window.location.reload();
    }, [autopayOffResult.responses, autopayOffResult.errors]);

    useEffect(() => {
        if (autopayResult1.responses == null) return;
        setAutoPayInfo(autopayResult1.responses);
    }, [autopayResult1.responses]);

    useEffect(() => {
        if (!accountsResult.responses) return;
        setAccountsLoaded(true);
        if (!accountsResult.responses.count) {
            setCreateAccount(true);
            return;
        }
        setAccounts(accountsResult.responses.accounts);
        formik.setFieldValue('bank_account', accountsResult.responses.accounts[0].id);
    }, [accountsResult.responses]);

    const onRadioChange = (e: any) => {
        e.persist();
        if (e.target.value === "total"){
            formik.setFieldValue('amount', parseFloat(balance.replace('$', '').replaceAll(',', '')));
            setBalance1(balance);
        }
        else if (e.target.value === "custom") {
            formik.setFieldValue('amount', '', false);
            setBalance1('0');
        }

        setIsTotal(!isTotal);
    }

    const deleteRecurring = (e: any) => {
        deleteAutopay({ method: 'POST', data: {enable: false}});
    }

    const onAccountChange = (e: any) => {
        e.persist();
        setAccount(e.target.value);
    };
    const onBalanceChange = (e: any) => {
        setBalance1(e.target.value);
    };

    const accountList: any = accounts.map((acc: any) => {
        return <option key={acc.id} value={acc.id}>{acc.nickname} ***{acc.account}</option>
    })

    function autopayOn() {

        console.log(autopayInfo);

        const { StartDate, NextScheduledRunTime, Amount } = autopayInfo;

        return (
            <div>
                <TitledBlock title='Recurring Payments'>
                    {error && <AlertMesssage type={'error'} message={error}></AlertMesssage>}
                    <Row show={true} style={{ justifyContent: 'space-between' }}>
                        <div style={{ paddingRight: 10, textAlign: 'left' }}>
                            <BigGreenText>Autopay is On</BigGreenText>
                            <DueDateText>Created on {StartDate}</DueDateText>
                            <BoldText>{autopayInfo.baccount}</BoldText>
                        </div>

                        <div>
                            <div>
                                <AutopayButton onClick={deleteRecurring}>Turn off Autopay</AutopayButton>
                            </div>
                        </div>

                    </Row>
                </TitledBlock>
                <TitledBlock title='Next Payment Details'>
                    <Row show={true}>
                        <BoldText style={{ flex: 2 }}>Your next payment is scheduled on: </BoldText><BigGreenText>{NextScheduledRunTime.split(' ')[0]}</BigGreenText>
                    </Row>
                    <Row show={true}>
                        <BoldText style={{ flex: 2 }}>Amount of the next payment is: </BoldText><BigGreenText>${Amount}</BigGreenText>
                    </Row>
                </TitledBlock>
            </div>
        )
    }

    function autopayOff() {
        return (
            <div>
                <TitledBlock title='Autopay Setup'>
                    <Row show={true} style={{ justifyContent: 'space-between' }}>
                        <div style={{ paddingRight: 10 }}>
                            {dueDate && <DueDateText>Due
                                {(() => {
                                    return days > 0 ? ' in ' + days + ' days' : null
                                })()}
                                {' '}as of {dueDate}</DueDateText>}
                            <BigGreenText>{balance}</BigGreenText>

                        </div>
                        <PaymentButtonBroup>
                            {currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_ach == '1' && <AccountLink to={{pathname: 'new_bank_account', state: { redirect: '/autopay' }}}>
                                <NewAccountButton>Add Bank Account</NewAccountButton>
                            </AccountLink>}
                            {currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_cc == '1' && <AccountLink to={{pathname: '/new_cc_account', state: { redirect: '/autopay' }}}>
                                <NewAccountButton>Add Credit Card</NewAccountButton>
                            </AccountLink>}
                            <AccountLink to={`/edit_accounts`}>
                                <EditAccountButton>Edit Payment Methods</EditAccountButton>
                            </AccountLink>
                        </PaymentButtonBroup>
                    </Row>
                </TitledBlock>

                {!createAccount && <Row show={accountsLoaded }>
                    <FormikProvider value={formik}>

                        <FormBlock onSubmit={formik.handleSubmit}>

                            {error && <AlertMesssage type={'error'} message={error}></AlertMesssage>}

                            <FormItem show={!createAccount}>
                                <Title>Select Bank Account *</Title>
                                <Field name="bank_account" value={account} onChange={onAccountChange} as="select" style={{ width: "100%", height: "30px", margin: "10px 0 25px", borderColor: "#ABB2B9" }}>
                                    {accountList}
                                </Field>
                            </FormItem>

                            <FormItem show={!createAccount}>
                                <Title>Start Date *</Title>
                                <Field name="start_date" type="date" style={{ width: "100%", height: "30px", margin: "10px 0 25px", borderColor: "#ABB2B9" }}>
                                </Field>
                                <ErrorMessage>{formik.touched.start_date && formik.errors.start_date ? formik.errors.start_date : null}</ErrorMessage>
                            </FormItem>

                            <FormItem show={!createAccount}>
                                <Title>End Date *</Title>
                                <Field name="end_date" as="select" style={{ width: "100%", height: "30px", margin: "10px 0 25px", borderColor: "#ABB2B9" }}>
                                    <option key={'lease_end'} value={'lease_end'}>Lease End Date</option>
                                    <option key={'cancel'} value={'cancel'}>Until Cancelled</option>
                                </Field>
                            </FormItem>

                            <FormItem show={true}>
                                <Title>Payment Amount *</Title>
                            </FormItem>

                            <FormItem show={true}>
                                <RadioGroup>
                                    <RadioButton>
                                        <RadioInput
                                            type="radio"
                                            id="total"
                                            name="amount-type"
                                            value="total"
                                            defaultChecked
                                            onChange={onRadioChange}
                                        />
                                        <RadioLabel htmlFor="total">Monthly Payment ({balance})</RadioLabel>
                                    </RadioButton>
                                    <RadioButton>
                                        <RadioInput
                                            type="radio"
                                            id="custom"
                                            name="amount-type"
                                            value="custom"
                                            onChange={onRadioChange}
                                        />
                                        <RadioLabel htmlFor="custom">Custom Amount</RadioLabel>
                                    </RadioButton>
                                </RadioGroup>
                            </FormItem>

                            <FormItem show={!isTotal} onChange={onBalanceChange}>
                                <Title>Enter Amount *</Title>
                                <TitleInput id="amount" type="text" error={formik.touched.amount && formik.errors.amount} {...formik.getFieldProps('amount')} />
                                <ErrorMessage>{formik.touched.amount && formik.errors.amount ? formik.errors.amount : null}</ErrorMessage>
                            </FormItem>
                            {fee != 0 && <div style={{marginTop:"25px", fontSize:"14px", textAlign: "right"}}>
                                {credit ? "Credit card" : "ACH"} fee: ${isNaN(fee) ? '' : fee.toFixed(2)} <hr/>
                                <span style={{fontWeight: 800}}>Total amount: ${isNaN(total) ? '' : total.toFixed(2) || ''}</span>
                            </div>}
                            <SubmitButtonWrap newAccount={createAccount}>
                                {createAccount ?
                                    <FormButton type="button" active={true} onClick={() => history.push(`/new_bank_account`)}>Next</FormButton>
                                    :
                                    <FormButton type="submit" active={!isSubmitting} disabled={isSubmitting}>Set Autopay</FormButton>
                                }
                                <CancelButton type="button" onClick={() => history.push(`/`)}>Cancel</CancelButton>
                            </SubmitButtonWrap>
                            {fee != 0 && <div style={{marginTop:"25px", fontSize:"12px", textAlign: "left", color: "grey"}}>
                                *please note that there will be an additional charge of ${isNaN(fee) ? '' : fee.toFixed(2)} as processing fees. <br/>Your total transaction will be ${isNaN(total) ? '' : total.toFixed(2) || ''}
                            </div>}

                        </FormBlock>

                    </FormikProvider>
                </Row>}
                {createAccount && <Row show={true}>
                    <FormikProvider value={formik}>
                        <FormBlock>
                            <FormItem show={true}>
                                <Title>Please add a bank account or credit card to enroll in autopay.</Title>
                            </FormItem>
                            <br/>
                            <FormItem show={true}>
                                <Title>Payment Amount *</Title>
                            </FormItem>

                            <FormItem show={true}>
                                <RadioGroup>
                                    <RadioButton>
                                        <RadioInput
                                            type="radio"
                                            id="total"
                                            name="amount-type"
                                            value="total"
                                            defaultChecked
                                            onChange={onRadioChange}
                                        />
                                        <RadioLabel htmlFor="total">Total Balance ({balance})</RadioLabel>
                                    </RadioButton>
                                    <RadioButton>
                                        <RadioInput
                                            type="radio"
                                            id="custom"
                                            name="amount-type"
                                            value="custom"
                                            onChange={onRadioChange}
                                        />
                                        <RadioLabel htmlFor="custom">Custom Amount</RadioLabel>
                                    </RadioButton>
                                </RadioGroup>
                            </FormItem>

                            <FormItem show={!isTotal}>
                                <Title>Enter Amount *</Title>
                                <TitleInput id="amount" type="text" error={formik.touched.amount && formik.errors.amount} {...formik.getFieldProps('amount')} />
                                <ErrorMessage>{formik.touched.amount && formik.errors.amount ? formik.errors.amount : null}</ErrorMessage>
                            </FormItem>

                            <SubmitButtonWrap newAccount={createAccount} >
                                <CancelButton type="button" onClick={() => history.push(`/`)}>Cancel</CancelButton>
                            </SubmitButtonWrap>

                        </FormBlock>

                    </FormikProvider>
                </Row>}
            </div>
        );
    }

    return (
        <Page title='Autopay' tabNavigation={true}>
            {createAccount && currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_ach == '1' && currentUserState.currentUser.settings.accept_cc == '0' && <Redirect to={{ pathname: 'new_bank_account', state: { redirect: '/autopay', gohome: true } }} />}
            {createAccount && currentUserState.currentUser && currentUserState.currentUser.settings && currentUserState.currentUser.settings.accept_ach == '0' && currentUserState.currentUser.settings.accept_cc == '1' && <Redirect to={{ pathname: 'new_cc_account', state: { redirect: '/autopay', gohome: true } }} />}

            {currentUserState.currentUser && currentUserState.currentUser.activelease && currentUserState.currentUser.activelease.restrict_payments == "1" && <Redirect to={"/"} />}
            {autopayInfo && autopayInfo!=null && autopayOn()}
            {accountsResult.responses && autopayInfo == false && autopayOff()}
        </Page>
    );
}

const validate = (values: any) => {

    const errors: any = {};

    if (!values.amount) errors.amount = 'Required';
    if (!values.start_date) errors.start_date = 'Required';
    else if (!/^\s*-?[1-9]\d*(\.\d{1,2})?\s*$/.test(values.amount)) errors.amount = 'Must contain valid amount';

    return errors;
};

export default AutopayPage;